import * as ProfileActionTypes from 'actiontypes/profile';
import ProfileService from 'services/ProfileService';

export { default as fetchProfile } from './fetchProfile';
export { default as fetchSharedContent } from './fetchSharedContent';
export { default as fetchSharedContentByUrl } from './fetchSharedContentByUrl';
export { default as shareContent } from './shareContent';
export { default as deleteEntry } from './deleteEntry';

const profileService = new ProfileService();

const updateDescriptionRequest = () => ({
  type: ProfileActionTypes.UPDATE_DESCRIPTION_REQUESTED,
  isFetching: true,
});

const updateDescriptionSuccess = (data, newDescription) => ({
  type: ProfileActionTypes.UPDATE_DESCRIPTION_SUCCESS,
  isFetching: false,
  newDescription,
});

const updateDescriptionFailure = () => ({
  type: ProfileActionTypes.UPDATE_DESCRIPTION_FAILURE,
  isFetching: false,
});


/** ----------------------------------------------------------------------------
 *  UPDATE DESC
 -----------------------------------------------------------------------------*/
export const updateDescription = newDescription => (dispatch) => {
  dispatch(updateDescriptionRequest());
  profileService.updateDescription(newDescription).then((response) => {
    dispatch(updateDescriptionSuccess(response.data, newDescription));
  }).catch((message) => {
    dispatch(updateDescriptionFailure(message));
  });
};


/** ----------------------------------------------------------------------------
*  SHARE CONTENT
-----------------------------------------------------------------------------*/

export const shareContentComplete = () => ({
  type: ProfileActionTypes.SHARE_CONTENT_COMPLETE,
});
